// extracted by mini-css-extract-plugin
export default {"BookRatingForm":"BookRatingForm_BookRatingForm__d33Hm","Stars":"BookRatingForm_Stars__xBRP-"};